import { __assign, __read } from "tslib";
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { findMarksInCluster } from '../../utils';
var pointMotion = {
    initial: 'hidden',
    animate: 'show',
    variants: { hidden: { opacity: 0 }, show: { opacity: 1 } },
    transition: { ease: 'easeInOut', delay: 0.1, duration: 0.3 },
};
var Step = function (_a) {
    var steps = _a.steps, marks = _a.marks, onMouseEnter = _a.onMouseEnter, onMouseMove = _a.onMouseMove, onMouseLeave = _a.onMouseLeave;
    var _b = __read(useState(null), 2), activeStep = _b[0], setActiveStep = _b[1];
    var filteredMarks = activeStep && findMarksInCluster(activeStep, marks, activeStep.height);
    return (React.createElement(React.Fragment, null,
        filteredMarks &&
            filteredMarks.map(function (mark) {
                var key = mark.key, color = mark.color, radius = mark.radius, x = mark.x, y = mark.y;
                return (React.createElement("g", { key: key },
                    React.createElement(motion.circle, __assign({ cx: x, cy: y, r: radius, fill: color }, pointMotion))));
            }),
        steps &&
            steps.map(function (item) {
                var transformedItem = __assign(__assign({}, item), { x: item.x + item.width / 2 });
                var key = transformedItem.key, x = transformedItem.middle, y = transformedItem.y, width = transformedItem.width, height = transformedItem.height;
                return (React.createElement("g", { key: key, onMouseEnter: function (e) {
                        onMouseEnter(e, transformedItem);
                        setActiveStep(transformedItem);
                    }, onMouseMove: function (e) {
                        onMouseMove(e, transformedItem);
                    }, onMouseLeave: function (e) {
                        onMouseLeave(e);
                        setActiveStep(null);
                    } },
                    React.createElement("rect", __assign({ x: x, y: y, height: height, width: width, fill: "transparent" }, pointMotion))));
            })));
};
export default Step;
